import { Flex } from 'antd';
import { useTranslation } from 'translations/hooks';

import { ShiftProductionGraph } from 'business/shift-report/report/components/ShiftProductionGraph';
import {
  ShowMoreOnMobileState,
  ShowMoreOnMobileStateKeys,
  SHOW_MORE_ON_MOBILE_STATE_KEYS,
} from 'business/shift-report/report/pages/ReportView/types';
import { GetShiftReportPdfMetadataQuery } from 'generated/graphql';
import { useMediaType } from 'technical/media/hooks';
import { ShowMoreToggle } from 'ui/show-more-button';
import { ShowMoreContainer } from 'ui/show-more-button/show-more-container';

import { MobileCardHeader } from './mobile-header';

type AvailabilityGraphContainerProps = {
  report: NonNullable<GetShiftReportPdfMetadataQuery['shiftReport']>;
  showMore: ShowMoreOnMobileState;
  toggleShowMore: (key: ShowMoreOnMobileStateKeys) => () => void;
};

export const AvailabilityGraphContainer = ({
  report,
  showMore,
  toggleShowMore,
}: AvailabilityGraphContainerProps) => {
  const { isMobile } = useMediaType();
  const { t } = useTranslation();

  return (
    <Flex
      vertical
      className="bloc"
      key="critical-tasks-pie-chart"
      gap={isMobile ? 8 : 0}
    >
      {isMobile ? (
        <MobileCardHeader>
          {t('pages.print.shiftProductionTime', { context: 'critical' })}
        </MobileCardHeader>
      ) : (
        <h1>{t('pages.print.shiftProductionTime', { context: 'critical' })}</h1>
      )}
      <ShowMoreContainer enableToggle={isMobile} toggleState={showMore.graph}>
        <ShiftProductionGraph report={report} />
      </ShowMoreContainer>
      <ShowMoreToggle
        enableToggle={isMobile}
        toggleState={showMore.graph}
        toggleFunc={toggleShowMore(SHOW_MORE_ON_MOBILE_STATE_KEYS.GRAPH)}
      />
    </Flex>
  );
};
